import {
  GET_ALL_ZONE,
  GET_ZONE_BY_ID,
  DELETE_ZONE_BY_ID,
  UPDATE_ZONE_BY_ID,
  ZONE_GET_ERROR,
  DELETE_ZONE_ERROR,
  UPDATE_ZONE_ERROR,
  GET_ZONE_REQUEST,
  ADD_ZONE,
  ADD_ZONE_ERROR,
} from "../../constant";

// **  Initial State
const initialState = {
  Zones: null,
  loading: false,
  error: false,
};

const ZoneReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ZONE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_ALL_ZONE:
      return {
        ...state,
        Zones: action.data,
        loading: false,
      };
    case ZONE_GET_ERROR:
      return {
        ...state,
        error: true,
        loading: false,
      };
    case ADD_ZONE:
      return {
        ...state,
        loading: false,
        error: false,
        Zones: action.data,
      };
    case ADD_ZONE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case GET_ZONE_BY_ID:
      return {
        ...state,
        loading: false,
        Zones: action.data,
      };
    case DELETE_ZONE_BY_ID:
      return {
        ...state,
        loading: false,
        Zones: action.data,
      };
    case DELETE_ZONE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case UPDATE_ZONE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case UPDATE_ZONE_BY_ID:
      return {
        ...state,
        loading: false,
        Zones: action.data,
      };
    default:
      return state;
  }
};

export default ZoneReducer;
